"use client";

import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { useContext } from "react";

import { UserContext } from "@/contexts/user-context";
import { APP_ROUTES } from "@/utils/constants";

export const IsLoggedIn = ({
  children,
  guestOnly,
}: {
  children: ReactNode;
  guestOnly?: boolean;
}) => {
  const { loggedIn } = useContext(UserContext);

  return (!guestOnly && loggedIn) || (!loggedIn && guestOnly) ? children : null;
};

export const TriggerLoggedInModalWindow = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  const { loggedIn } = useContext(UserContext);
  const router = useRouter();

  return loggedIn ? (
    children
  ) : (
    <div
      className={className}
      onClickCapture={(e) => {
        e.stopPropagation();
        e.preventDefault();
        router.push(APP_ROUTES.signUp);
        return false;
      }}
    >
      {children}
    </div>
  );
};

// TODO just replace this hook with the context itself?
export const useIsLoggedIn = () => {
  const { loggedIn } = useContext(UserContext);

  return loggedIn;
};
